import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,

};

export const getBulkResumeList = createAsyncThunk(
    "getBulkResumeList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/countriesStates/fetch-states-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const BulkResumeSlice = createSlice({
    name: "BulkResumeSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getBulkResumeList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getBulkResumeList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getBulkResumeList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default BulkResumeSlice.reducer;
